(function ($) {
	'use strict';

	$.fn.formDetectOnchange = function(options) {
		var settings = $.extend({container : ''}, options);
		
		return this.each(function () {
			let $self = $(this);
			$(document).on('change', $self, function () {
				// Detect changes on form
				if($self.is(':visible')) {
					if(typeof settings.container === 'object') {
						$self.closest(settings.container).addClass('is_dirty');
					} else {
						$self.addClass('is_dirty');
					}
				}
			});
		});
	}
})(jQuery);